import Vue from 'vue';
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';

const ifilVendorContract = require('./ifilVendorContractV3.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.ifilVendorContractAddressV3;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(ifilVendorContract.abi, contractAddress) : '',
} 

const getIfilVendorAddressV3 = () => {
  return contractAddress;
}

const getIfilVendorContractV3 = () => {
  return contractConst.contract;
}


const vendorActiveABSV3 = ([_prodid], options, callback) => {
  return $web3js.send(getIfilVendorContractV3().methods.activeABS, [_prodid], options, callback);
}

const vendorActiveABSEstimateSendV3 = async ([_prodid], options) => {
  let gasPromise = $web3js.estimateSend(getIfilVendorContractV3().methods.activeABS, [_prodid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const vendorWithdrawV3 = ([_prodid], options, callback) => {
  return $web3js.send(getIfilVendorContractV3().methods.withdraw, [_prodid], options, callback);
}

const vendorWithdrawEstimateSendV3 = async ([_prodid], options) => {
  let gasPromise = $web3js.estimateSend(getIfilVendorContractV3().methods.withdraw, [_prodid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}


export default {
  getIfilVendorAddressV3,
  getIfilVendorContractV3,
  vendorActiveABSV3,
  vendorActiveABSEstimateSendV3,
  vendorWithdrawV3,
  vendorWithdrawEstimateSendV3,
}


// WEBPACK FOOTER //
// ./src/lib/contract/ifilVendorV3/index.js